import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    width: -webkit-fill-available;
    margin-top: 75px;
    @media (min-width: 720px) {
        margin-top: 20px;
        margin-left: 176px
    }
`;

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    padding: 10px 20px;
    gap: 10px;

    @media (min-width: 720px) {
        display: flex;
        flex-direction: row;
        justify-content: ${({ $top }) => $top ? 'space-between' : 'space-around'};
        padding: 10px 0;
        width: 100%;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .selects {
        display: flex;
        flex-direction: column;
        gap: 20px;

        @media (min-width: 720px) {
            flex-direction: row;
        }
    }

    .buttons-container {
        align-items: center;
        display: flex;
        gap: 10px;
        justify-content: space-around;
        
        @media (min-width: 720px) {
            flex-direction: row;
            width: 50%;
        }
    }
`;

export const BodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 25px;
    gap: 25px;
`;

export const ContainerTable = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: auto;
`

export const Table = styled.table`
    width: 100%;
    border-collapse: separate;
    border-spacing: 0px 10px;
    border: 0px; 
`;

export const TableHeader = styled.th`
    padding: 8px;
    text-align: center;
    border: 0px; 
    color: #333;
    font-weight: 900;
`;

export const TableRow = styled.tr`
    border: 0px; 
`;

export const TableCell = styled.td`
    border: 1px solid #ddd;
    padding: 8px;
    border: 0px; 
`;

export const TableCellItem = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 0px;
    padding-right: 0px;
    text-align: center;
    height: 100%;
    margin-left: 10px;
    margin-top: 0px;
    margin-right: 0px;
    color: black;
    white-space: nowrap;
    border: 1px solid black;
    border-radius: 5px;
    padding-inline: 5px;
    background: ${({ $alarm }) => {return (
        $alarm === 0 ? '#BBEBD5' :
        $alarm === 1 ? '#F8FFCC' : 
        $alarm === 2 ? '#FFCCD5' :
        '#fff')
    }};
`;

export const GraphContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-block: 15px;
`;

export const ContainerSpinner = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const NoData = styled.span`
    color: #333;
    leading-trim: both;
    text-edge: cap;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const ContainerIten = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;